import axios from "axios";
import { useUserStore } from "@/stores/user";
import { ElMessage } from "element-plus";

const http = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 10000,
});

http.interceptors.request.use((config) => {
  const userStore = useUserStore();
  const { token } = userStore;
  if (token) config.headers.token = token;
  return config;
});

http.interceptors.response.use(
  (response) => {
    const data = response.data || {};
    const code = data.code || 200;
    const msg = data.message || data.msg || "请求失败";

    if (code === 401) {
      const userStore = useUserStore();
      userStore.logout().finally(() => {
        if (!sessionStorage.getItem("hasRedirected")) {
          sessionStorage.setItem("hasRedirected", "true");
        }
      });
      return Promise.reject(new Error(msg));
    }

    if (code === 500) {
      ElMessage({ message: msg, type: "error" });
      return Promise.reject(new Error(msg));
    }

    return data;
  },
  (error) => {
    const msg = error?.response?.data?.message
      || error?.response?.data?.msg
      || error?.message
      || "请求失败";
    return Promise.reject(new Error(msg));
  }
);

export default http;
